import React from 'react';
import { ClientContext } from '@thd-nucleus/app-render/dist/client';
import B2BTheme from '@thd-olt-global/b2b-theme';
import { NewRelicBridge } from '@thd-olt-component-react/new-relic-bridge';
import { whyDidYouRender } from '../wdyr';
import { App } from './App';
import { getRoutes } from './routes';

/* Called by src/client.jsx rather than run on import. package.json marks every
/* module but stylesheets side-effect free, so a bare `import './entry-client'`
/* is tree-shaken away and the production entry chunk ships empty. */
export const startClient = () => {
  NewRelicBridge.init();
  whyDidYouRender.init();

  document.addEventListener('DOMContentLoaded', async () => {
    const client = new ClientContext();
    client.setExperienceRoutes(getRoutes());
    if (client.customer.type === 'b2b') {
      client.setTheme({ name: 'b2b', template: B2BTheme });
    }
    const userId =
      client.customer.userId || window.THDCustomer?.default.userID || '';
    const customerAccountId =
      client.customer.svocId || window.THDCustomer?.default.svocID || '';

    client.render(
      <App customerAccountId={customerAccountId} userId={userId} />,
    );
  });
};
